module.exports = __webpack_public_path__ + "static/media/Karma.cee9e33f.png";